/**
 * Frontend conditional visibility for fields and form steps.
 */

'use strict';

var twentyninetimesCustomForm = twentyninetimesCustomForm || {};

twentyninetimesCustomForm.ConditionalLogic = {
    initialize: function(formular) {
        if (!formular || formular.getAttribute('data-conditional-logic-ready') === 'true') return;

        formular.setAttribute('data-conditional-logic-ready', 'true');
        formular.addEventListener('input', this.evaluate.bind(this, formular));
        formular.addEventListener('change', this.evaluate.bind(this, formular));
        this.evaluate(formular);
    },

    evaluate: function(formular) {
        var containers = Array.from(formular.querySelectorAll('.customform-field-container'));

        containers.forEach(function(container) {
            var stepVisible = this.evaluateElement(container, formular);
            this.setVisibility(container, stepVisible, true);

            Array.from(container.querySelectorAll('.customform-field[data-conditional-logic]')).forEach(function(field) {
                var fieldVisible = stepVisible && this.evaluateElement(field, formular);
                this.setVisibility(field, fieldVisible, false);
            }, this);
        }, this);

        this.syncCurrentStep(formular);
    },

    evaluateElement: function(element, formular) {
        var rawConfig = element.getAttribute('data-conditional-logic');
        if (!rawConfig) return true;

        var config;
        try {
            config = JSON.parse(rawConfig);
        } catch (error) {
            return true;
        }

        if (!config.conditional_logic_enabled) return true;
        var groups = Array.isArray(config.conditional_logic_groups) ? config.conditional_logic_groups : [];
        if (!groups.length) return true;

        var completeGroups = groups.filter(function(group) {
            var rules = group && Array.isArray(group.rules) ? group.rules : [];
            return rules.length > 0 && rules.every(function(rule) { return Boolean(rule && rule.field); });
        });
        if (!completeGroups.length) return true;

        var matches = completeGroups.some(function(group) {
            var rules = group && Array.isArray(group.rules) ? group.rules : [];
            return rules.length > 0 && rules.every(function(rule) {
                return this.evaluateRule(
                    this.getFieldValue(formular, rule.field || ''),
                    rule.operator || 'is',
                    rule.value || ''
                );
            }, this);
        }, this);

        return (config.conditional_logic_action || 'show') === 'show' ? matches : !matches;
    },

    getFieldValue: function(formular, identifier) {
        if (!identifier) return '';

        var fields = Array.from(formular.querySelectorAll('.customform-field[data-field-identifier]'));
        var field = null;
        fields.some(function(candidate) {
            if (candidate.getAttribute('data-field-identifier') === identifier) {
                field = candidate;
                return true;
            }
            return false;
        });

        if (!field || field.classList.contains('customform-conditionally-hidden') || field.closest('.customform-field-container.customform-conditionally-hidden')) {
            return '';
        }

        var type = field.getAttribute('data-field-type');
        if (type === 'checkbox') {
            return Array.from(field.querySelectorAll('input[type="checkbox"]:checked')).map(function(input) {
                return input.value;
            }).filter(Boolean).join(', ');
        }
        if (type === 'radio') {
            var checked = field.querySelector('input[type="radio"]:checked');
            return checked ? checked.value : '';
        }

        var input = field.querySelector('input, select, textarea');
        return input ? String(input.value || '') : '';
    },

    evaluateRule: function(submittedValue, operator, ruleValue) {
        submittedValue = String(submittedValue || '');
        ruleValue = String(ruleValue || '');

        switch (operator) {
            case 'is': return submittedValue === ruleValue;
            case 'is_not': return submittedValue !== ruleValue;
            case 'contains': return submittedValue.indexOf(ruleValue) !== -1;
            case 'not_contains': return submittedValue.indexOf(ruleValue) === -1;
            case 'starts_with': return submittedValue.indexOf(ruleValue) === 0;
            case 'ends_with': return ruleValue === '' || submittedValue.slice(-ruleValue.length) === ruleValue;
            case 'empty': return submittedValue === '' || submittedValue === '0';
            case 'not_empty': return submittedValue !== '' && submittedValue !== '0';
            default: return false;
        }
    },

    setVisibility: function(element, visible, isStep) {
        element.classList.toggle('customform-conditionally-hidden', !visible);
        element.setAttribute('aria-hidden', visible ? 'false' : 'true');

        if (!isStep) {
            element.hidden = !visible;
        }

        Array.from(element.querySelectorAll('input, select, textarea, button')).forEach(function(control) {
            if (!visible) {
                if (!control.disabled) {
                    control.disabled = true;
                    control.setAttribute('data-conditionally-disabled', 'true');
                }
            } else if (control.getAttribute('data-conditionally-disabled') === 'true') {
                control.disabled = false;
                control.removeAttribute('data-conditionally-disabled');
            }
        });
    },

    syncCurrentStep: function(formular) {
        if (!formular.classList.contains('form-has-steps')) return;

        var steps = Array.from(formular.querySelectorAll('.customform-field-container'));
        var available = steps.filter(function(step) {
            return !step.classList.contains('customform-conditionally-hidden');
        });
        var current = null;
        available.some(function(step) {
            if (step.classList.contains('current')) {
                current = step;
                return true;
            }
            return false;
        });
        current = current || available[0];

        steps.forEach(function(step) {
            var isCurrent = step === current;
            step.classList.toggle('current', isCurrent);
            step.classList.toggle('hidden', !isCurrent);
            step.style.display = isCurrent ? 'block' : 'none';
        });

        var submitButton = formular.querySelector('.customform-submit');
        if (submitButton && current) {
            var buttonText = current.getAttribute('data-step-btn-text');
            if (buttonText) submitButton.innerText = buttonText;
            submitButton.setAttribute('type', 'button');
        }
    },

    getNextAvailableStep: function(currentContainer) {
        var next = currentContainer ? currentContainer.nextElementSibling : null;
        while (next) {
            if (next.classList.contains('customform-field-container') && !next.classList.contains('customform-conditionally-hidden')) {
                return next;
            }
            next = next.nextElementSibling;
        }
        return null;
    }
};
